import React, { Component } from 'react'
import PropTypes from 'prop-types'

import constants from '../../config/constants'
import { isHashPathSame } from '../../utils/hashPaths'

import CustomTourOperator from '../../containers/TourOperator/CustomTourOperator'
import V1SelectField from '../V1SelectField'

class TourOperatorSelector extends Component {
  componentDidMount() {
    this.props.requestUser()
  }

  componentDidUpdate() {
    if (this.props.fetchTourOperators) {
      this.props.requestTourOperators()
    }
  }

  updateTouroperatorCode = code => {
    this.props.requestChangeUserCustomTOPCode(code)

    // Only request the new filtered tourOperators when on the seat trade page.
    // This is needed to show the correct tourOperators which the currently selected tourOperator
    // can trade with.
    if (isHashPathSame(constants.seatTrade)) {
      this.props.requestFilteredTourOperators()
    }
  }

  render() {
    const {
      tourOperators,
      classes,
      userTourOperatorCode,
      showTourOperatorSelector,
    } = this.props

    if (!showTourOperatorSelector) return null

    return (
      <div className={classes.container}>
        <div className={classes.topSelection}>
          <V1SelectField
            options={tourOperators}
            value={userTourOperatorCode}
            onChange={this.updateTouroperatorCode}
            selectClassName={classes.selectField}
            selectIconClassName={classes.selectFieldIcon}
          />
          <CustomTourOperator />
        </div>
      </div>
    )
  }
}

TourOperatorSelector.propTypes = {
  requestTourOperators: PropTypes.func.isRequired,
  tourOperators: PropTypes.array,
  classes: PropTypes.shape({
    container: PropTypes.string,
    topSelection: PropTypes.string,
    title: PropTypes.string,
    selectField: PropTypes.string,
    selectFieldIcon: PropTypes.string,
  }),
  requestUser: PropTypes.func.isRequired,
  userTourOperatorCode: PropTypes.string,
  requestChangeUserCustomTOPCode: PropTypes.func.isRequired,
  showTourOperatorSelector: PropTypes.bool,
  fetchTourOperators: PropTypes.bool,
}

TourOperatorSelector.defaultProps = {
  touroperators: [],
  showTourOperatorSelector: false,
  fetchTourOperators: false,
}

export default TourOperatorSelector
